import React, { FC } from 'react';

interface CustomSkeletonElementProps {
  skeletonContainerClassName: string;
  skeletonChildrenClassName?: string;
  childrenCount?: number;
}

const defaultProps = {
  skeletonChildrenClassName: '',
  childrenCount: 0,
};

export const CustomSkeletonElement: FC<CustomSkeletonElementProps> = ({
  skeletonContainerClassName,
  skeletonChildrenClassName,
  childrenCount,
}) => {
  const skeletonChildren = Array.from({ length: childrenCount || 0 }, (_, index) => (
    <div key={index} className={skeletonChildrenClassName} />
  ));

  return <div className={skeletonContainerClassName}>{skeletonChildren}</div>;
};

CustomSkeletonElement.defaultProps = defaultProps;
